/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format, validate & minify JSON`)
};

const es_jf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatea, valida y minifica JSON`)
};

const de_jf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON formatieren, validieren & minimieren`)
};

const nl_jf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatteer, valideer & minimaliseer JSON`)
};

const fr_jf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formater, valider et minifier JSON`)
};

const it_jf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatta, valida e minimizza JSON`)
};

const pt_br2_jf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatar, validar e minificar JSON`)
};

const pt_jf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatar, validar e minificar JSON`)
};

const ja_jf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONをフォーマット、検証、minify`)
};

const zh_jf_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`格式化、验证与压缩 JSON`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jf_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jf_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jf_nav_main_desc", locale)
	if (locale === "en") return en_jf_nav_main_desc(inputs)
	if (locale === "es") return es_jf_nav_main_desc(inputs)
	if (locale === "de") return de_jf_nav_main_desc(inputs)
	if (locale === "nl") return nl_jf_nav_main_desc(inputs)
	if (locale === "fr") return fr_jf_nav_main_desc(inputs)
	if (locale === "it") return it_jf_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_jf_nav_main_desc(inputs)
	if (locale === "pt") return pt_jf_nav_main_desc(inputs)
	if (locale === "ja") return ja_jf_nav_main_desc(inputs)
	return zh_jf_nav_main_desc(inputs)
};